import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InboxInsertPaymentLinkFormComponent } from './inbox-insert-payment-link-form.component';
import { ConversationDetail } from '../../../../../../core/src/lib/interface/conversation.interface';
import { take } from 'rxjs';
@Component({
  selector: 'inbox-insert-payment-link',
  template: '',
  standalone: false,
})
export class InboxInsertPaymentLinkComponent {
  @Input() conversationDetail: ConversationDetail;
  @Output() insertLink = new EventEmitter();

  constructor(public modal: MatDialog) {}

  openInsertLinkModal(): void {
    const modalRef$ = this.modal.open(InboxInsertPaymentLinkFormComponent, {
      width: '500px',
      data: {
        conversationDetail: this.conversationDetail,
      },
    });
    modalRef$
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.insertLink.emit(res);
        }
      });
  }
}
